import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createCaseTagsAPI,
  updateCaseTagsAPI,
  getCaseTagsAPI,
  CheckCaseTagswithCaseDetailsAPI,
  deleteCaseTagsAPI,
  bulkAddOrRemoveCaseTagsAPI,
} from "../../../api/caseTags_api";

export const getCaseTagsAction = createAsyncThunk(
  "caseTags/getCaseTags",
  async (values, { rejectWithValue }) => {
    const response = await getCaseTagsAPI(values);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createCaseTagsAction = createAsyncThunk(
  "caseTags/createCaseTags",
  async (caseTagsData, { rejectWithValue }) => {
    const response = await createCaseTagsAPI(caseTagsData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateCaseTagsAction = createAsyncThunk(
  "caseTags/updateCaseTags",
  async ({ caseTags_ID, caseTagsData }, { rejectWithValue }) => {
    const response = await updateCaseTagsAPI(caseTags_ID, caseTagsData);

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteCaseTagsAction = createAsyncThunk(
  "caseTags/deleteCaseTags",
  async (caseTags_ID, { rejectWithValue }) => {
    const response = await deleteCaseTagsAPI(caseTags_ID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const CheckCaseTagswithCaseDetailsAPIAction = createAsyncThunk(
  "caseTags/CheckCaseTagswithCaseDetails",
  async (caseTags_ID, { rejectWithValue }) => {
    const response = await CheckCaseTagswithCaseDetailsAPI(caseTags_ID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const bulkAddOrRemoveCaseTagsAction = createAsyncThunk(
  "caseTags/bulkAddOrRemoveCaseTags",
  async ({ caseNectNumbers, caseTagIds, action }, { rejectWithValue }) => {
    const response = await bulkAddOrRemoveCaseTagsAPI(
      caseNectNumbers,
      caseTagIds,
      action,
    );
    if (!response.success) {
      return rejectWithValue(response.error || "Failed to add tags");
    }
    return response.data;
  },
);
